/**
 * DER / binary helpers for Hub iframe SSO.
 *
 * CRITICAL: `@dfinity` / `@icp-sdk` `PublicKey.toDer()` returns **ArrayBuffer**,
 * which is NOT iterable. Looping `for (const b of toDer())` throws
 * `TypeError: t is not iterable` and breaks guest → host sub-delegation.
 */

/** Encode DER / raw bytes as base64 for `OS_II_DELEGATION_REQUEST.publicKeyDerBase64`. */
export function derBytesToBase64(bytes: ArrayBuffer | Uint8Array): string {
  const view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  let bin = "";
  for (const b of view) bin += String.fromCharCode(b);
  return btoa(bin);
}

/** Decode base64 DER from a guest into Uint8Array for `Ed25519PublicKey.fromDer`. */
export function bytesFromBase64(b64: string): Uint8Array {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}
